export default {
  path: '/iot',
  name: 'Iot',
  redirect: { name: 'IotSensor' },
  component: () => import('@/views/iot'),
  meta: {
    title: '物联网',
    showTabBar: true
  },
  children: [
    {
      path: 'sensor',
      name: 'IotSensor',
      meta: {
        showTabBar: true
      },
      component: () => import('@/views/iot/sensor')
    },
    {
      path: 'camera',
      name: 'IotCamera',
      meta: {
        showTabBar: true
      },
      component: () => import('@/views/iot/camera')
    }
  ]
}
